import React, { useEffect, useState } from "react";
import FlexComponent from "../../FlexComponent";
import { getTrackingMsgs } from "../../../utils/urls";
import axios from '../../../utils/axios';
import { contactLabel, hasCoBorrowerContact, normalizeContacts } from "../../../utils/contacts";


function MessageTracker({ formId }) {

    const [isVisble, setIsvisible] = useState(false)
    const [data, setData] = useState([])
    const [contacts, setContacts] = useState([])
    const [expandedStages, setExpandedStages] = useState(new Set())
    const isMultiContact = hasCoBorrowerContact(contacts)

    const toggleStage = (stageId) => {
        setExpandedStages(prev => {
            const next = new Set(prev);
            if (next.has(stageId)) next.delete(stageId);
            else next.add(stageId);
            return next;
        });
    };

    // by_contact entries in contacts order; ids missing from contacts go last.
    // The applicant's "repeat" contact is folded into the primary row (same person).
    const stageBreakdown = (byContact) => {
        if (!byContact || typeof byContact !== "object") return [];
        const list = normalizeContacts(contacts);
        const primaryId = list.find(c => c.role === "primary")?.ghl_contact_id;
        const rows = {};
        Object.keys(byContact).forEach(id => {
            const isRepeat = list.find(c => c.ghl_contact_id === id)?.role === "repeat";
            const key = isRepeat && primaryId ? primaryId : id;
            const row = rows[key] || (rows[key] = { id: key, emails: 0, sms: 0, calls: 0 });
            row.emails += byContact[id]?.emails || 0;
            row.sms += byContact[id]?.sms || 0;
            row.calls += byContact[id]?.calls || 0;
        });
        const order = list.map(c => c.ghl_contact_id);
        const rank = (id) => order.includes(id) ? order.indexOf(id) : order.length;
        return Object.values(rows).sort((a, b) => rank(a.id) - rank(b.id));
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        return new Date(dateStr).toLocaleDateString("en-US", {
            month: "long",
            day: "2-digit",
            year: "numeric",
        });
    };


    const getTrackingsFn = () => {
        const labelsUrl = `${getTrackingMsgs}${formId}/`
        axios.get(labelsUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response.data)
                    setData(response.data.stages)
                    setContacts(response.data.contacts || [])
                    // setSelectedLists(response.data)
                }
            })
            .catch((error) => {
                // setAppLeads(null)
            })
    }

    useEffect(() => {
        getTrackingsFn()
    }, [])

    return (
        <div >
            <FlexComponent style={{ paddingBottom: ".5rem" }}>
                <div>💬 Communication Activity</div>
                <FlexComponent style={{ paddingBottom: ".6rem" }} width="auto" gap="1rem" >
                    <div style={{ cursor: "pointer" }} onClick={() => {
                        setIsvisible(!isVisble)
                    }} ><i className={isVisble ? 'pi pi-minus' : 'pi pi-plus'} style={{ marginRight: "25px" }} ></i> </div>
                </FlexComponent>
            </FlexComponent>

            {isVisble && data?.map((stage) => {
                const breakdown = isMultiContact ? stageBreakdown(stage.by_contact) : [];
                const isExpanded = expandedStages.has(stage.stage_id);
                return (
                <div
                    key={stage.stage_id}
                    style={{
                        border: "1px solid grey",
                        borderRadius: "8px",
                        padding: "12px",
                        marginBottom: "12px"
                    }}
                >
                    <h4 style={{ marginBottom: "5px" }} > <span style={{color: "#ACACAC", fontWeight : "400"}} >{stage.pipeline_name}</span> - {stage.stage}</h4>
                    <p style={{ marginBottom: "5px" }}>
                        <span style={{color: "#ACACAC", fontWeight : "400"}} >Date:</span> {formatDate(stage.start_date)} → {formatDate(stage.end_date)}
                    </p>

                    <div style={{ display: "flex", gap: "16px" }}>
                        <span>📧 Emails: {stage.emails}</span>
                        <span>💬 SMS: {stage.sms}</span>
                        <span>📞 Calls: {stage.calls}</span>
                        {breakdown.length > 0 && (
                            <span
                                onClick={() => toggleStage(stage.stage_id)}
                                style={{ marginLeft: "auto", cursor: "pointer", color: "#B1B1B1", fontSize: "12px", display: "flex", alignItems: "center", gap: "5px" }}
                            >
                                <i className={`pi pi-chevron-${isExpanded ? 'up' : 'down'}`} style={{ fontSize: 10 }} />
                                By person
                            </span>
                        )}
                    </div>

                    {isExpanded && breakdown.length > 0 && (
                        <div style={{ marginTop: "8px", paddingTop: "8px", borderTop: "1px solid #ffffff26", display: "flex", flexDirection: "column", gap: "4px", fontSize: "13px" }}>
                            {breakdown.map((row) => (
                                <div key={row.id} style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
                                    <span style={{ color: "#ACACAC", minWidth: "180px" }}>{contactLabel(contacts, row.id)}</span>
                                    <span>📧 {row.emails || 0}</span>
                                    <span>💬 {row.sms || 0}</span>
                                    <span>📞 {row.calls || 0}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                );
            })}
        </div>
    );
}

export default MessageTracker;
